import setAgentLocalState from 'actions/agent_local_state/set_agent_local_state';
import { SidePanelType } from 'models/side_panel';

export default class OpenAnswerPanel {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, compositionId }) {
    this.context.stores.languages.setLoading();
    this.context.gateways.language.fetch();

    const sidePanel = this.context.stores.sidePanel.get();
    if (!sidePanel.isShowing(SidePanelType.ANSWER)) {
      sidePanel.show(SidePanelType.ANSWER);
      this.context.stores.sidePanel.set(sidePanel);

      const localState = this.context.stores.agentLocalState.get();
      localState.setSidePanel(sidePanel);
      localState.setAnswerPanelLastOpenedAt(sidePanel.panelLastShownAt);
      setAgentLocalState(this.context, localState);
    }

    this.context.analytics.track('Answer Panel Opened', { customerId, conversationId, compositionId });
  }
}
